import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux'
import InfoModal from './InfoModal';

function copyToClipboard(text,successState) {
    const textField = document.createElement('textarea')
    textField.innerText = text
    const parentElement = document.body
    parentElement.appendChild(textField)
    textField.select()
    document.execCommand('copy')
    parentElement.removeChild(textField)
}

export const FileButtons = ({ visible, finalVersionFilePath, buttonClass }) => {
    const [ pathCopied, setPathCopied ] = useState(false)
    
    if( !visible || typeof(finalVersionFilePath) === 'undefined' || finalVersionFilePath === '' ) {
        return (<span/>)
    }

    const openText = 'Open'
    const fullButtonClass = 'btn btn-primary btn-mr ' + buttonClass

    const isPathLink = (path) => {
        if( path.match(/^http/i) ) {
            return true
        }
        return false
    }
    
    if( isPathLink(finalVersionFilePath) ) {
        return (
            <a
                href={finalVersionFilePath}
                target="_blank"
                key="open-button"
                className={fullButtonClass} rel="noreferrer">
                {openText}
            </a>
        )
    }
    
    const callback = () => {
        if( finalVersionFilePath === '' ) {
            return
        }
        copyToClipboard(finalVersionFilePath)
        setPathCopied(true)
        setTimeout(() => {
            setPathCopied(false)
        }, 750)
    }
    
    return (
        <div>
            <button
                onClick={callback}
                className={fullButtonClass}>
                Copy Filepath to Clipboard
            </button>
            <span>
                &nbsp;
                {pathCopied &&
                 <span>Copied!</span>
                }
            </span>
        </div>
    )
}

const CopyIcon = ({ value, buttonClass, httpAsDefault, setShowCopied }) => {
    if( typeof(value) === 'undefined' ) {
        return null
    }
        
    if( ( value.length > 0 && value.match(/^http/i) ) || ( value === '' && httpAsDefault ) ) {
        return null
    }

    let callback = function() {
        copyToClipboard(value)
        setShowCopied(true)
        setTimeout(() => {
            setShowCopied(false)
        }, 750)
    }

    const className = 'btn btn-primary btn-mr ' + buttonClass
    return (
        <span className="input-group-btn">
            <button type="button" className={className} onClick={callback} style={{marginRight: 0}}>
                <span style={{color: '#fff'}}>
                    Copy Filepath to Clipboard
                </span>
            </button>
        </span>
    )
}

const OpenIcon = ({ value, buttonClass, httpAsDefault }) => {
    if( typeof(value) === 'undefined' ) {
        return null
    }
    
    if( ( value.length > 0 && ! value.match(/^http/i) ) || ( value === '' && ! httpAsDefault ) ) {
        return null
    }
    
    const className = 'btn btn-primary btn-mr ' + buttonClass
    
    // So, if it should show, but it's empty, can't be clickable
    if ( value === '' ) {
        return (
            <span className="input-group-btn">
                <button type="button" className={className} style={{color: '#fff', marginRight: 0}}>
                    Open
                </button>
            </span>
        )
    }
    
    return (
        <span className="input-group-btn">
            <button type="button" className={className} style={{marginRight: 0}}>
                <a href={value} target="_blank" style={{color: '#fff'}} rel="noreferrer">
                    Open
                </a>
            </button>
        </span>
    )
}

const PathInputGroup = ({
    value,
    buttonClass,
    httpAsDefault,
    disabled,
    placeholder,
    canDelete,
    deleteFilePath,
    changeFilePath,
    required,
    showLabel,
    label,
    isFirst,
    isOriginal,
    previousVersionFilePaths,
}) => {
    const [ showCopied, setShowCopied ] = useState(false)

    let helpBlock = []
    let deleteButton = null
    if( showCopied ) {
        helpBlock.push(<span key="help-block-1">Copied!</span>)
    }
    if( showCopied && canDelete ) {
        helpBlock.push(<span key="help-block-2"> | </span>)
    }
    if( canDelete ) {
      deleteButton = (
        <small className="form-info-text">
          <a className="delete" onClick={() => deleteFilePath() }>
            Delete
          </a>
        </small>
      )
    }

    let callback = function() {
        copyToClipboard(value)
        setShowCopied(true)
        setTimeout(() => {
            setShowCopied(false)
        }, 750)
    }

    const labelBlock = showLabel ? (
        <span>
            <span className="block">{label}</span>
            <small className="font-normal">{isFirst ? '(Read Only)' : '(Editable)'}</small>
        </span>
    ) : null
    
    const inputElement = disabled ? (
        <input className="form-control pointer"
               style={{backgroundColor: "#eee"}}
               type="text"
               value={value}
               data-tooltip-id="gnctooltip" data-tooltip-content="Copy Filepath to Clipboard"
               onClick={callback}
        />
    ) : (
        <input className="form-control"
               type="text"
               value={value}
               onChange={(e) => changeFilePath(e.target.value)}
               disabled={disabled}
               placeholder={placeholder}
        />
    )

    const copyPreviousVersion = () => {
        changeFilePath(previousVersionFilePaths[0])
    }
    
    const copy = isOriginal && !disabled && previousVersionFilePaths && previousVersionFilePaths?.length > 0 & previousVersionFilePaths[0] !== "" ?
                 (
                     <small className="form-info-text"
                            data-tooltip-id="gnctooltip"
                            data-tooltip-content="Copy the Original (Editable) File Location from the previous version of this document. (This is a copy-paste and will not automatically update if either are changed.)">
                         <a className="add-from-previous" onClick={() => copyPreviousVersion() }>
                             Add Location from previous version
                         </a>
                     </small>
                 ) :
                 null
    
    return (
        <div className="form-group">
            <label className={`col-sm-2 control-label ${required && isFirst ? 'required' : ''}`}>
                {labelBlock}
            </label>
            <div className="col-sm-8">
                <div className="input-group">
                    <OpenIcon
                        value={value}
                        buttonClass={buttonClass}
                        httpAsDefault={httpAsDefault}
                    />
                    <CopyIcon
                        value={value}
                        buttonClass={buttonClass}
                        httpAsDefault={httpAsDefault}
                        setShowCopied={(value) => setShowCopied(value)}
                    />
                    {inputElement}
                </div>
                <span className="m-b-none">
                    {copy}
                    {deleteButton}
                    &nbsp;
                    {helpBlock}
                </span>
            </div>
        </div>
    )
}

const FilePaths = ({
    disabled,
    filePaths,
    previousVersionFilePaths,
    setFilePaths = () => {},
    finalVersionFilePath,
    setFinalVersionFilePath,
    filePathsInUse,
    finalVersionFilePathInUse,
    showFileLabels,
    showRequired,
    displayOriginal,
    buttonClass,
    finalVersionLabel,
}) => {
    const pscState = useSelector(state => state.pscState.value)
    const config = pscState.config || {}

    const httpAsDefault = config.file_paths_use_http_as_default === '1' ? true : false
    const placeholderFirst = httpAsDefault
                           ? 'Enter full URL (e.g \'https://dropbox.com/Private/Filename.pdf\')'
                           : 'Enter the full path, including filename. e.g \'N:\\Documents\\Filename.pdf\''
    const placeholder = httpAsDefault
                      ? 'Enter full URL (e.g \'https://dropbox.com/Private/Filename.docx\')'
                      : 'Enter the full path, including filename. e.g \'N:\\Documents\\Filename.docx\''

    const [ displayFilepathModal, setDisplayFilepathModal ] = useState(false)

    if ( ! filePathsInUse ) {
        return (
            <>
            <div className="form-group" key="filepaths-1">
                <label className="col-sm-2 control-label"></label>
                <div className="col-sm-8">
                    <label className="control-label">
                        File Location
                    </label>
                </div>
            </div>
            <div className="form-group" key="filepaths-2">
                <label className="col-sm-2 control-label">
                </label>
                <div className="col-sm-8">
                    No Files under configuration control
                </div>
            </div>
            </>
        )
    }
    
    const addFilePath = () => {
        setFilePaths([...filePaths, ''])
    }

    const deleteFilePath = (index) => {
        setFilePaths(filePaths.filter((_, i) => i !== index))
    }

    const changeFilePath = (index, value) => {
        setFilePaths(filePaths.map((path, i) => i === index ? value : path))
    }
    
    const infoModalBodyContent = (
        <div>
            <div className="modal-item"> How files are opened depends on your system configuration, and where your files are stored.</div>
            <div className="hr-line-dashed"></div>
            <div className="modal-item"> <i className="fa fa-copy"/> <strong>Copy Filepath to Clipboard</strong> </div>
            <div className="modal-item"> For files stored <strong>locally</strong>, <strong>outside</strong> of GNC Go.</div>
            <div className="modal-item"> <strong>1.</strong> Copy Filepath to Clipboard</div>
            <div className="modal-item"> <strong>2.</strong> Open a Windows File Explorer</div>
            <div className="modal-item"> <strong>3.</strong> Paste into the File Explorers path field</div>
            <div className="modal-item"> <strong>4.</strong> Press Enter, your file will open directly</div>
            <div className="hr-line-dashed"></div>
            <div className="modal-item"> <i className="fa fa-file-o"/> <strong>Open</strong> </div>
            <div className="modal-item"> For files stored <strong>on a web-server</strong>, <strong>outside</strong> of GNC Go.</div>
            <div className="modal-item"> <strong>1.</strong> Click the Open icon</div>
            <div className="modal-item"> <strong>2.</strong> Your file will open or download directly (depending on your browser settings)</div>
        </div>
    )

    return (
        <>
        <div className="form-group" key="filepaths-1">
            <label className="col-sm-2 control-label"></label>
            <div className="col-sm-8">
                <label className="control-label">
                    File Location
                </label>
                <a className="modal-question-circle use-filepath-modal-icon" role="button" onClick={() => setDisplayFilepathModal(true)}>
                    <i className="fa fa-question-circle" />
                </a>
            </div>
        </div>
        <InfoModal
            title="To Open a File"
            titleIcon="fa fa-info-circle"
            bodyContent={infoModalBodyContent}
            show={displayFilepathModal}
            onClose={() => setDisplayFilepathModal(false)}
        />
        {finalVersionFilePathInUse &&
         <PathInputGroup
             isFirst
             value={finalVersionFilePath}
             buttonClass={buttonClass}
             httpAsDefault={httpAsDefault}
             placeholder={disabled ? '' : placeholderFirst}
             changeFilePath={setFinalVersionFilePath}
             disabled={disabled}
             required={showRequired}
             showLabel={showFileLabels}
             label={finalVersionLabel || "Issued"}
         />
        }
        {filePaths.map((path,i) => {
            const isOriginal = displayOriginal && i === 0;

            return <PathInputGroup
                       key={`path-input-group-${i}`}
                       value={path}
                       buttonClass={buttonClass}
                       httpAsDefault={httpAsDefault}
                       placeholder={disabled ? '' : placeholder}
                       canDelete={!disabled && !isOriginal}
                       changeFilePath={(value) => changeFilePath(i, value)}
                       deleteFilePath={() => deleteFilePath(i)}
                       disabled={disabled}
                       required={showRequired}
                       isOriginal={isOriginal}
                       previousVersionFilePaths={previousVersionFilePaths}
                       showLabel={isOriginal && showFileLabels}
                       label={isOriginal ? "Original" : ""}
                   />
         })}
        
        {!disabled ?
            <div className="form-group" key="add-file-path">
                <label className="col-sm-2 control-label"></label>
                <div className="col-sm-8">
                    <button type="button" className="btn btn-xs btn-primary" onClick={addFilePath}>Add</button>
                </div>
            </div>
        : null}
        </>
    )
}

export default FilePaths
